/** Bond-type config for Name_Change_Principal picker (endorse + rider). */

export const ENDORSEMENT_PRINCIPAL_PICKER_CONFIG = {
  Probate: {
    retrieve: (bondId) => `/retrieve-probate-bond/${bondId}/`,
    listKey: "personal_rep",
    idField: "pr_id",
    nameField: "name",
    pickerLabel: "Personal representative (Principal)",
  },
  Guardianship: {
    retrieve: (bondId) => `/retrieve-guardianship-bond/${bondId}/`,
    listKey: "guardians",
    idField: "guardian_id",
    nameField: "guardian_name",
    pickerLabel: "Guardian (Principal)",
  },
  VA: {
    retrieve: (bondId) => `/retrieve-va-bond/${bondId}/`,
    listKey: "principals",
    idField: "fid_id",
    nameField: "name",
    pickerLabel: "Fiduciary (Principal)",
  },
  Trustee: {
    retrieve: (bondId) => `/retrieve-trustee-bond/${bondId}/`,
    listKey: "trustees",
    idField: "trustee_id",
    nameField: "name",
    pickerLabel: "Trustee (Principal)",
  },
};

export const BOND_TYPES_WITH_PRINCIPAL_PICKER = Object.keys(
  ENDORSEMENT_PRINCIPAL_PICKER_CONFIG
);

export function getPrincipalPickerConfig(bondType) {
  return ENDORSEMENT_PRINCIPAL_PICKER_CONFIG[bondType] || null;
}

export function principalDisplayName(row, config) {
  if (!row || !config) return "";
  const name = row[config.nameField];
  if (name && String(name).trim()) return String(name).trim();
  const id = row[config.idField];
  return id != null ? `#${id}` : "";
}
